import React from "react";
import { imageUrl } from "core/lib";

const attachmentUploaded = imageUrl("file.svg");
const broken_file = imageUrl("broken_file.svg");

type AttachmentProps = {
  file: any,
  removeAttachmentHandler: any
}

const Attachment = (props: AttachmentProps) => {
  const {
    file,
    removeAttachmentHandler,
    // isRemoved,
  } = props;

  const removeAttachment = () => {
    removeAttachmentHandler();
  };

  const units = ["bytes", "KB", "MB", "GB", "TB"];

  const formattedFileSize = (size: number) => {
    for (let i = 4; i > 0; i--) {
      const cap = Math.pow(1024, i);
      if (size >= cap) {
        return (size / cap).toFixed(2) + " " + units[i];
      }
    }

    return `${size.toString()} bytes`;
  }

  const fileName = file.overSize || file.notSupported ?
    broken_file :
    attachmentUploaded;

  return (
    <li>
      <img src={fileName} alt="" />

      <span>
        {file.name}
        {!file.notSupported && <small>{file.notSupported ? "" : formattedFileSize(file.size)}</small>}
        {file.notSupported && <em>File not uploaded</em>}
      </span>

      <i className="icon-close" onClick={removeAttachment} />
    </li>
  );
};

export default Attachment;
